import React, { useEffect } from 'react';
import ENV from "../../constants/environment";
import { PostApiData } from '../../api/general';
import { PostRRTransferRequest, PostRRTransferResponse, RRTransferPayload, RRVirtualSenderAlias } from '../../types/api/readyremit';
import { ROUTES } from '../../constants/api';
import i18n from '../../i18n/config';
import { RR_RSP, RR_TRANSFER_METHODS } from '../../constants/enums';
import { trackEvent } from '../../services/eventTracker';
import { EVENTS } from '../../constants/events';

declare global {
  interface Window {
    rremit: any;
  }
}

const Iframe = ({ iframe, rsp, transferMethod, token, balanceCheck }: { iframe: string, rsp: string, transferMethod: string, token: string, balanceCheck: RRVirtualSenderAlias }) => {
  const customerId = ENV.RR_CUSTOMER_ID;

  useEffect(() => {
    initializeSDK();
  }, []);

  const initializeSDK = () => {
    const formattedRsp = rsp.charAt(0).toUpperCase() + rsp.slice(1).toLowerCase();

    window.rremit.init(
      {
        sdkCore: {
          customerId,
          resources: token,
          transferMethod,
          rsp: formattedRsp
        },
        sdkColors: {
          brandPrimary: "#338bf2"
        },
        sdkFeatures: {
          darkMode: false // DEFAULT false
        },
        virtualSenderAccounts: [
          {
            alias: balanceCheck.alias,
            balance: balanceCheck.balance,
            last4: Number(balanceCheck.last4),
            srcProviderId: balanceCheck.externalId
          }
        ]
      },
      async (eventPayload: RRTransferPayload) => {
        try {
          const requestBody: PostRRTransferRequest = {
            rsp,
            transferMethod,
            quoteBy: eventPayload.transfer.quoteBy,
            quoteHistoryId: eventPayload.transfer.quoteHistoryId,
            recipientId: eventPayload.transfer.recipientId,
            recipientAccountId: eventPayload.transfer.recipientAccountId,
            fields: eventPayload.transfer.fields
          }
          const url = ROUTES.READY_REMIT.POST_TRANSFER;
          const response = await PostApiData<PostRRTransferRequest, PostRRTransferResponse>(url, requestBody);
          if (rsp === RR_RSP.VISA && transferMethod === RR_TRANSFER_METHODS.PUSH_TO_CARD) {
            trackEvent(EVENTS.READY_REMIT.PUSH_TO_CARD.SDK_SUCCESS);
          }
          window.rremit.completed(response.result);
        } catch (error) {
          if (rsp === RR_RSP.VISA && transferMethod === RR_TRANSFER_METHODS.PUSH_TO_CARD) {
            trackEvent(EVENTS.READY_REMIT.PUSH_TO_CARD.SDK_FAILURE);
          }
          const errorObj = {
            response: {
              data: {
                code: error?.status ?? 500,
                message: error?.data?.errors[0]?.errorMessage || i18n.t("PAGES.READY_REMIT.SDK.ERROR_MESSAGE"),
              }
            }
          }
          window.rremit.failed(errorObj);
        }
      }
    );
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: iframe || "" }}
      className="full-height spacing-bottom-medium"
    />
  );
}

export default Iframe;